module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('p', {
    staticClass: "toc-p"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#h1.1"
    }
  }, [_vm._v("Why Bake Bread?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#h1.2"
    }
  }, [_vm._v("Breaking The Rules (Myth And Mystique vs Reality)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#h1.3"
    }
  }, [_vm._v("Tools Of The Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#h1.4"
    }
  }, [_vm._v("Hands, Hunches And How To Use Them")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#h1.5"
    }
  }, [_vm._v("Flour, Water, Yeast And Salt – Down To Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#h1.6"
    }
  }, [_vm._v("Just For Starters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DAILY BREADS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Focaccia: Basic Dough for Loaves or Flatbreads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fougasse de Collioure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosemary Filoncino")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ciabatta (Slipper Bread)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kalamata Olive Filoncino")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hazelnut/Sage Filoncino")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Filoncino Integrale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sourdough Caraway Rye")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shimek Dill Pickles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pane Casereccio (Housewife’s Bread)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole-Wheat Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pane Rustico")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Daily_Breads#h1.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Baguette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRADITIONAL BREADS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anadama Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Mother’s Cream Bread (Pan de Mie)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Mother’s Sourdough Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttermilk Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Fruit Purée")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Grandmother’s Beaten Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skillet Corn Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornmeal Spoon Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sourdough Flapjacks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buckwheat Blini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston Brown Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suzanne’s Version of Boston Baked Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Traditional_Breads#h1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIZZA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Pizza Crust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza Bianca alla Romana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza Margherita")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza Napoletana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza with Potatoes and Rosemary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza con Carciofi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza Quattro Stagione")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza alla Griglia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Very Thin Pizza with Rocket Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Pizza#h1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simply Perfect Tomato Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SWEET LOAVES AND OTHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Brioche")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bigmama’s Kolaches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poppy Seed Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prune Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cottage Cheese Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot Focaccia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prune and Walnut Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schiacciata with Roasted Grapes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suzanne’s Roasted Grapes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sourdough Lemon Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golden Cornmeal Torta della Nonna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gabriella’s Ricotta Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Ricotta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brownie Scout Chocolate Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foolproof Chocolate Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Foolproof Chocolate Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Curd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Tozzetti (Roman Dipping Cookies)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Sweet_Loaves_and_others#h1.21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Turkey Chocolate Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPECIAL BREADS AND BREADSTICKS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot-Plum Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hard Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Panettone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Orange and Lemon Zest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russian Kulich with Pashka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pink Sugar Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pashka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Chappati for Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ye-Wolo Ambasha (African Spiced Bread)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nit’ r K’Ibe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berberé")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truffle Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Special_Breads_and_Breadsticks#h1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosemary-Pepper Breadsticks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEFTOVERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Panzanella (Bread Salad)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Panzanella")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Scallop Panzanella")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.3a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bruschette")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Tomato and Basil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Rocket and Prosciutto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Sweet Peppers and Tuna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Caponata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Olive Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Wild Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Roasted Garlic and Parmesan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta with Shellfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.11a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bruschettine")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#page_161",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bread Soufflés")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread and Cheese Soufflé")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread Soufflé with Salmon and Capers")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.13a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bread in Pasta and Rice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Penne with Broccoli and Anchovies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rotelle alla Romana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orecchiette with Broccoli Rape and Hot Peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supplí")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pasta con le Sarde")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.18a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bread Soups")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuscan Bread Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot, Celeriac, Onion, and Parmesan Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pappa di Pomodoro")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Bean and Balsamic Vinegar Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suzanne’s Rich Chicken Stock")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.23a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bread for Dessert")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Bread and Butter Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Bread Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Apples and Cream on Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pears in Caramel with Cheese on Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.27a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Exotic Croutons and Breadcrumbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Leftovers#h1.28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Croutons and Breadcrumbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BREAD FOR CHILDREN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pie Crust Pinwheels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Very Own Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egyptian Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Log Cabin Scrambles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alphabet Breadsticks (Basic Recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pain Perdú (Lost Bread)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Campfire Rolly Polys")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bread_for_Children#h1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adam and Eve on a Raft")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0